import useProfileCommonStore from '../use-profile-common-store';
import get from 'lodash/get';

import { useProfileInterestCreditingRates } from '../../../hooks/api';

const useInterestCreditingRates = ({ isTIAAQdia }) => {
  const { apiConfigBase } = useProfileCommonStore();
  const interestCreditingRates = useProfileInterestCreditingRates(apiConfigBase);

  const asOfDate = get(interestCreditingRates, 'data.asOfDate', null);
  const dateFrom = get(interestCreditingRates, 'data.dateFrom', null);
  const dateTo = get(interestCreditingRates, 'data.dateTo', null);
  const items = get(interestCreditingRates, 'data.items', []);

  const SECURE_INCOME_DISCLOSURE = `Interest credited to the TIAA Secure Income Account includes a guaranteed rate, plus additional amounts as may be established by the TIAA Board of Trustees. Additional amounts are not guaranteed for periods other than the period for which they are declared. All guarantees under contracts issued by TIAA are based on TIAA's claims-paying ability. Past performance is no guarantee of future results.`;

  const descriptionText = {
    body: isTIAAQdia
      ? SECURE_INCOME_DISCLOSURE
      : `TIAA Traditional is designed primarily to help meet your long-term retirement income needs; it is not a short-term savings vehicle.  TIAA Traditional provides a guaranteed minimum interest rate and the opportunity for additional amounts due to our sharing-the-profits approach. TIAA has credited more than the guaranteed rate on one or more contracts every year since 1948 (as of 1/1/2024).`,
    emphasis: `Please click on "more information" link for important disclosures.`,
    headline: `The actual amount of interest you earn on your TIAA ${isTIAAQdia ? 'Secure Income Account balance' : 'Traditional Annuity'} depends on when you make contributions.`
  };

  return {
    asOfDate,
    dateFrom,
    dateTo,
    descriptionText,
    tableData: items
  };
};

export default useInterestCreditingRates;
